<div class=" dropdown-menu dropdownProjectUpdates dropdown-menu-right project-updates">
  <div class="section">

    <h3 class="title main">{{locale.LABEL_PROJECT_UPDATES}}</h3>

  </div>


  <tabset  class="tabs-container">
    <tab  name="updates_Section_Tab"  id="updates_Section_Tab">
      <ng-template tabHeading>
        <i class="" name="updates_Section"></i>Updates<span class="badge count-badge">{{ projectUpdatesService.updatesInfo.updatesCount }}</span>
      </ng-template>



      <div class="section no-updates" *ngIf="!projectUpdatesService.updatesInfo.updatesCount">
        <h4 class="title">{{locale.LABEL_NO_UPDATES_AVAILABLE}}</h4>
      </div>

      <div class="section" *ngIf="projectUpdatesService.updatesInfo.sourceCodeUpdatesCount">
        <h4 class="title">{{locale.TITLE_SOURCE_CODE_UPDATES}} {{'(' + projectUpdatesService.updatesInfo.sourceCodeUpdatesCount + ')'}}</h4>
        <p class="description">{{locale.LABEL_SOURCE_CODE_UPDATES}}</p>
        <a (click)="dropdown.hide(); openSourceCodeUpdatesDialog()">{{locale.LABLE_SHOW_DETAILS}}</a>
      </div>

      <div class="section" *ngIf="projectUpdatesService.updatesInfo.hasVcsUpdates" >
        <h4 class="title">{{locale.LABEL_VCS_UPDATES}}</h4>
        <p class="description">{{locale.MESSAGE_VCS_PROJECT_PULL_MESSAGE}}</p>
        <button class="button-primary btn app-button" (click)="dropdown.hide();pullChanges()">{{locale.LABEL_VCS_MENU_PULL_PROJECT}}</button>
      </div>

      <div class="section" *ngIf="projectUpdatesService.updatesInfo.artifactsUpdatesCount" >
        <h4 class="title">{{locale.LABEL_ARTIFACT_UPDATES}} {{projectUpdatesService.updatesInfo.artifactsUpdatesCount && '(' + projectUpdatesService.updatesInfo.artifactsUpdatesCount + ')' || ''}}</h4>
        <p class="description">{{locale.MESSAGE_ARTIFACT_UPDATES}}</p>
        <a (click)="dropdown.hide(); showDetails()" name="show_More_Details">{{locale.LABLE_SHOW_DETAILS}}</a>
      </div>
    </tab>
    <tab  name="jobs_Section_Tab" id="jobs_Section_Tab">
      <ng-template tabHeading>
        <i class="jobs" name="job_Section"></i>Jobs<span class="badge count-badge">{{jobstatusService.jobDataInProgress.length}}</span>
      </ng-template>

      <wms-job-menu></wms-job-menu>
    </tab>
  </tabset>
</div>
